module.exports = __webpack_public_path__ + "static/media/footer-award-3.cee180a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/footer-award-3.png
// module id = 509
// module chunks = 0